export default __webpack_public_path__ + "static/media/datadog.a761520d.svg";